/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Title_TextInputs */

const en_import_title_text = /** @type {(inputs: Import_Title_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasted text`)
};

const de_import_title_text = /** @type {(inputs: Import_Title_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingefügter Text`)
};

/**
* | output |
* | --- |
* | "Pasted text" |
*
* @param {Import_Title_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_title_text = /** @type {((inputs?: Import_Title_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Title_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_title_text(inputs)
	return en_import_title_text(inputs)
});